import axios from "axios"

export const base_url = "https://rubypy.com";

export const postFormData = async(params) => {
  return await axios.post(`${base_url}/api-v1/client-enquiries/`, params)
}

